import { validator } from '../core'
import { NAME_REGEX } from '../regex/name.regex'

const minimumCharacters = 2

export const nameValidation = (fieldName: string) => {
  return validator
    .string()
    .required(`${fieldName} is required.`)
    .min(minimumCharacters, `${fieldName} must contain at least 2 characters`)
    .test(
      'validationCharacters',
      `${fieldName} must include valid characters (letters, dashes, apostrophes and periods)`,
      (value) => {
        return /^[a-zA-Z\s\-\.']+$/g.test(value)
      }
    )
    .test('validationType', 'Please enter a valid first name', (value) => {
      return !NAME_REGEX.test(value)
    })
}
